module.exports = __webpack_public_path__ + "static/media/task-pending-icon.f3de868d.svg";